module.exports = __webpack_public_path__ + "media/images/bg/mosaic/brushes-6475a02fcd5c5b4f8e1693f27f6e3099.svg";